import starImg from '../../assets/img/icon-star-48.png'
import githubLogo from '../../assets/img/icon-github-50.png'
import linkedinLogo from '../../assets/img/icon-linkedin-50.png'
import CVLogo from '../../assets/img/icon-cv-50.png'
import playstoreLogo from '../../assets/img/disponible-en-google-play-badge.png'

export const infoSpanish = {
    buttonMessage: 'Genial !',
    firstInfo: {
     shown: false,
     title: "Bienvenido/a!",
     description: `Te invito a mi portafolio virtual. Usa las flechas de tu teclado para moverte. Aún está en fase de prueba pero espero que lo disfrutes!.  
     Si deseas leer mi información debes recoger todas las monedas del escenario.
     Buena suerte. No te caigas por el precipicio!`,
     button: 'Sigamos !',
    },
    secondInfo: {
      shown: false,
      title: "Sobre mí",
      description: `<p>Me llamo Ibelitze, soy una fullstack developer con más de 9 años de experiencia, me considero la loca de javascript jajaja (o así me gusta llamarme). Soy una gran apasionada de ese lenguaje, pero la vida me ha llevado por el camino de aprender también PHP, Python, y otras tecnologías. </p>
        <p>Como fullstack tengo la capacidad de trabajar tanto el Frontend como el Backend, lo cual me hace un profesional bastante completo y eso me permite tener conocimiento amplio de muchos sistemas y tecnologías. Mi código es limpio y ordenado. Siempre dispuesta a aprender cosas nuevas, adaptarme a cualquier entorno laboral y a dar lo mejor de mí.</p>
        <p>Me considero senior aunque aún estoy en proceso de aprender cosas nuevas. En éste portafolio te enseño una de mis más grandes pasiones: los videojuegos!. Porque si no estoy programando, estoy jugando… o aprendiendo cómo se hacen los videojuegos!.</p>
        <p>Sigue agarrando más monedas para que puedas leer más sobre mí <3 </p>
        `,
        button: 'Sigamos !',
    },
    thirdInfo: {
        shown: false,
        title: "Lenguajes que manejo",
        description: `<strong class="strong-title">Uy! Se viene lo bueno! </strong>
            <p>Pues de <strong>Javascript</strong> manejo cosillas como: javascript vanilla, Jquery, Typescript, Angular, ReactJS, VueJS, NextJS, Ionic + React, Redux, y NodeJS. </p>
            <p>De <strong>PHP</strong> manejo: PHP vanilla, Codeigniter, Laravel y Symphony </p>
            <p>También he trabajado con <strong>Python</strong> en el lado del backend <3 </p>
            <p>Para <strong>CSS</strong> te tengo: CSS vanilla, Bootstrap, Talwind, SCSS y un Flexbox bien salvaje <3 </p>
        `,
        button: 'Sigamos !',
    },
    fourthInfo: {
        shown: false,
        title: "Otras tecnologías importantes",
        description: `
            <p>He trabajado constantemente con: GIT, Webpack, Vite, Bun, NPM, AWS, Google cloud services, REST, JSON, ZOD, APIs en general de todo tipo, Wordpress, Perfex CRM, Salesforce CRM, Brevo CRM, Dynamics 365 CRM, CI/CD, entre otros. </p>
            <p>Manejo de <strong>bases de datos:</strong> Firebase, MongoDB, MYSQL, SQL en general. </p>
            <p>Para <strong>testing</strong> casi siempre uso Jest.</p>
            <p>Para <strong>metodología de trabajo</strong> he manejado: Kanban y Scrum.</p>
            <p>Estoy segura que hay más cositas, pero espacio es lo que no hay… si tienes dudas: me preguntas :D </p>
        `,
        button: 'Sigamos !',
    },
    fifthInfo: {
        shwon: false,
        title: "Felicidades! Has ganado el juego",
        description: `<div class="box-stars">
            <img class="golden-star" src="${starImg}" alt="estrella dorada de premio" />
            <img class="golden-star" src="${starImg}" alt="estrella dorada de premio" />
            <img class="golden-star" src="${starImg}" alt="estrella dorada de premio" />
        </div>
        <strong>Si llegaste hasta aquí es porque te interesa mi perfil! :D </strong>
        <p>Ahora comparto contigo todos mis canales de comunicación, mi CV y mi Linkedin. Gracias por disfrutar mi portafolio, es un placer para mí compartirlo.</p>
        <p>( en mi github puedes conseguir el código base :O )</p>
        <p>Tlf: (+51) 981 413 994</p>
        <p>Correo: ibelitzeportafolio@gmail.com</p>
        <div class="box-icons">
            <a target="_blank" href="https://github.com/ibelitze"><img class="icon github" alt="icono de Github" src="${githubLogo}" /></a>
            <a target="_blank" href="https://www.linkedin.com/in/ibelitze-zambrano-fullstack/"><img class="icon linkedin" alt="icono de Linkedin" src="${linkedinLogo}" /></a>
            <a target="_blank" href="https://drive.google.com/drive/folders/1ttVzv5Zr0ZdTEijabmXyw12mhA-lW07v?usp=sharing"><img class="icon linkedin" alt="icono de Linkedin" src="${CVLogo}" /></a>
        </div>`,
        button: 'Gracias !',
    },
    sixthInfo: {
        shown: false,
        title: "Tambien tengo un proyecto personal",
        description: `
            <p>Tengo una APP para Android llamada: Tarot encantado </p>
            <p>Está hecha con el framework Ionic/Capacitor + React</p>
            <p>El backend está construido con NodeJS y montado en una VM de Google Cloud</p>
            <p>Adicionalmente a ello, maneja Authenticator y todos los temas de seguridad con Firebase</p>
            <p>Para la triangulación de los pagos estoy usando la api de: RevenueCat</p>
            <p>Si quieres descargar la APP, haz click aquí: </p>
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.tarotencantado.app"><img class="icon playstore" alt="icono de Play Store" src="${playstoreLogo}" /></a>
        `,
        button: 'Sigamos !',
    }
 };


 export const infoEnglish = {
    buttonMessage: 'Great !',
    firstInfo: {
     shown: false,
     title: "Welcome!",
     description: `Welcome to my virtual portfolio. Use the arrow keys to navigate. It's still in testing, but I hope you enjoy it! 
     If you want to read my information, you must collect all the coins in the scene. Good luck. Don't fall off the cliff!`,
     button: 'Great !',
    },
    secondInfo: {
      shown: false,
      title: "About me",
      description: `<p>My name is Ibelitze, a full-stack developer with over 9 years of experience. I consider myself a JavaScript freak, hahaha ​(or so I like to call myself). I'm a huge fan of the language, but life has led me down a path to learning PHP, Python, and other technologies as well.</p>
        <p>As a full-stack developer, I have the ability to work on both the front and backend, which makes me a well-rounded professional and allows me to have extensive knowledge of many systems and technologies. My code is clean and organized. I'm always willing to learn new things, adapt to any work environment, and give my best.</p>
        <p>I consider myself a senior, although I'm still learning new things. In this portfolio, I'll show you one of my greatest passions: video games! Because if I'm not programming, I'm playing... or learning how to make video games!</p>
        <p>Keep grabbing more coins so you can read more about me <3</p>
        `,
      button: 'Lets keep going !',
    },
    thirdInfo: {
        shown: false,
        title: "Languages",
        description: `<strong class="strong-title">Hey! Here comes the good stuff! </strong>
            <p>On <strong>Javascript</strong> i'm good with: javascript vanilla, Jquery, Typescript, Angular, ReactJS, VueJS, NextJS, Ionic + React, Redux, and NodeJS. </p>
            <p>On <strong>PHP</strong> i'm good with: PHP vanilla, Codeigniter, Laravel and Symphony </p>
            <p>I also have worked with <strong>Python</strong> on the backend <3 </p>
            <p>For <strong>CSS</strong> i got for you: CSS vanilla, Bootstrap, Talwind, SCSS and a very sexy Flexbox!</p>
        `,
        button: 'Lets keep going !',
    },
    fourthInfo: {
        shown: false,
        title: "Other important technologies",
        description: `
            <p>I have worked with: GIT, Webpack, Vite, Bun, NPM, AWS, Google cloud services, REST, JSON, ZOD, API of any kind, Wordpress, Perfex CRM, Salesforce CRM, Brevo CRM, Dynamics 365 CRM, CI/CD, among others. </p>
            <p>I handle <strong>databases as:</strong> Firebase, MongoDB, MYSQL, SQL in general.</p>
            <p>For <strong>testing</strong> i always use Jest.</p>
            <p>For <strong>agile methodologies</strong> i have worked using: Kanban and Scrum.</p>
            <p>I'm sure there are more things, but there is no space... if you have any questions: ask me :D </p>
        `,
        button: 'Lets keep going !',
    },
    fifthInfo: {
        shwon: false,
        title: "Congratulations! you won",
        description: `<div class="box-stars">
            <img class="golden-star" src="${starImg}" alt="Golden star" />
            <img class="golden-star" src="${starImg}" alt="Golden star" />
            <img class="golden-star" src="${starImg}" alt="Golden star" />
        </div>
        <strong>If you're here is because you're interested on my profile! :D </strong>
        <p>I'm now sharing all my communication channels, my CV, and my LinkedIn profile with you. Thank you for enjoying my portfolio; it's a pleasure for me to share it.</p>
        <p>( Are you interested in the source code of this portfolio?. You will find it in my Github :D )</p>
        <p>Phone: (+51) 981 413 994</p>
        <p>Email: ibelitzeportafolio@gmail.com</p>
        <div class="box-icons">
            <a target="_blank" href="https://github.com/ibelitze"><img class="icon github" alt="icono de Github" src="${githubLogo}" /></a>
            <a target="_blank" href="https://www.linkedin.com/in/ibelitze-zambrano-fullstack/"><img class="icon linkedin" alt="icono de Linkedin" src="${linkedinLogo}" /></a>
            <a target="_blank" href="https://drive.google.com/drive/folders/1ttVzv5Zr0ZdTEijabmXyw12mhA-lW07v?usp=sharing"><img class="icon linkedin" alt="icono de Linkedin" src="${CVLogo}" /></a>
        </div>`,
        button: 'Thanks !',
    },
    sixthInfo: {
        shown: false,
        title: "I also have a personal project",
        description: `
            <p>I have an Android APP called: Tarot encantado </p>
            <p>It's made with the Ionic/Capacitor + React framework</p>
            <p>The backend is built with NodeJS and hosted on a Google Cloud VM</p>
            <p>Additionally, it handles Authenticator and all security aspects with Firebase</p>
            <p>For payment triangulation, I'm using the RevenueCat API</p>
            <p>If you want to download the APP, click here: </p>
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.tarotencantado.app"><img class="icon playstore" alt="icono de Play Store" src="${playstoreLogo}" /></a>
        `,
        button: 'Lets go !',
    }
 };

export const classesForPopups = {
    showClass: {
        popup: `
          animate__animated
          animate__fadeInUp
          animate__faster
        `
      },
    hideClass: {
        popup: `
          animate__animated
          animate__fadeOutDown
          animate__faster
        `
    }
};